module.exports = __webpack_public_path__ + "static/media/Wasmachine.37d1dca1.mp3";